var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconSearchteaser18 = function SvgAIconSearchteaser18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    stroke: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99985 11.9997C10.2089 11.9997 11.9997 10.2089 11.9997 7.99985C11.9997 5.79079 10.2089 4 7.99985 4C5.79079 4 4 5.79079 4 7.99985C4 10.2089 5.79079 11.9997 7.99985 11.9997Z",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.332 11.3331L13.9986 14",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAIconSearchteaser18 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE4IDE4IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNy45OTk4NSAxMS45OTk3QzEwLjIwODkgMTEuOTk5NyAxMS45OTk3IDEwLjIwODkgMTEuOTk5NyA3Ljk5OTg1QzExLjk5OTcgNS43OTA3OSAxMC4yMDg5IDQgNy45OTk4NSA0QzUuNzkwNzkgNCA0IDUuNzkwNzkgNCA3Ljk5OTg1QzQgMTAuMjA4OSA1Ljc5MDc5IDExLjk5OTcgNy45OTk4NSAxMS45OTk3WiIgc3Ryb2tlLXdpZHRoPSIxLjciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgLz4KPHBhdGggZD0iTTExLjMzMiAxMS4zMzMxTDEzLjk5ODYgMTQiIHN0cm9rZS13aWR0aD0iMS43IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+Cjwvc3ZnPg==";